import { render, staticRenderFns } from "./UserPermission.vue?vue&type=template&id=95a2c1c0&"
import script from "./UserPermission.vue?vue&type=script&lang=js&"
export * from "./UserPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports